import React, { useState, useEffect } from "react";
import { Box, useTheme, InputBase, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SearchIcon from "@mui/icons-material/Search";
import { getPrestamoAmoxarifado, getProductoAmoxarifado, getStockAmoxarifado } from "../../services/amoxarifado.services";
import ModalImage from "../../modal/imagen/modalImagen";
import { getApiImagen } from "../../utils/getApiBaseUrl";

const PrestamoAmoxarifado = () => {
  const [data, setData] = useState([]); 
  const [selectedImage, setSelectedImage] = useState(null); 
  const [searchValue, setSearchValue] = useState(""); // Valor del campo de búsqueda
  const [filteredData, setFilteredData] = useState([]); // Datos filtrados para la tabla

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Definir columnas de la tabla
  const columns = [
    { field: "id", headerName: "ID", flex: 0.1 },
    {
      field: "producto",
      headerName: "Producto",
      flex: 0.8,
      cellClassName: "name-column--cell",
    },
    {
      field: "cantidad",
      headerName: "Cantidad",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cantidad_devuelta",
      headerName: "Devuelto",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "saldo",
      headerName: "Diferencia",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "create_at",
      headerName: "Fecha",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "sector",
      headerName: "Sector",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "valor_patrimonio",
      headerName: "Patrimonio",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
     {
      field: "usuario_re",
      headerName: "Prestado a",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
         {
      field: "id_ticket",
      headerName: "Ticket",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
        field: "imagen",
        headerName: "Imagen",
        flex: 0.3,
        headerAlign: "left",
        align: "left",
        renderCell: (params) => (
            <img 
                src={`${getApiImagen()}${params.value}`} 
                alt="Producto" 
                style={{ width: "100px", height: "100px", objectFit: "cover" }} 
                onClick={() => handleImageClick(`${getApiImagen()}${params.value}`)}
            />
        ),
    }
  ];

    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const handleCloseImageModal = () => {
        setSelectedImage(null);
    };


useEffect(() => {
  const fetchProducto = async () => {
    try {
      const response = await getPrestamoAmoxarifado();

      // Convertir cantidad a valor absoluto
      const transformedData = response.map((item) => ({
        ...item,
        cantidad: Math.abs(item.cantidad),
      }));

      setData(transformedData);
      setFilteredData(transformedData);
    } catch (error) {
      console.error("Error al obtener los grupos del backend:", error);
    }
  };

  fetchProducto();
}, []);


  // Manejar la búsqueda en la tabla
  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    // Filtrar los datos en base al valor de búsqueda
    const filtered = data.filter((item) =>
      item.producto.toLowerCase().includes(value.toLowerCase()) 
      );
    
    setFilteredData(filtered);
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header title="Prestamos" subtitle="Lista de los prestamos" />
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"40%"}
            width={"90%"}
            ml={1}
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={filteredData}
          getRowId={(row) => row.id} // Acceder correctamente al campo `Id`
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          disableMultipleSelection={true}
        />
        <ModalImage
                open={Boolean(selectedImage)}
                onClose={handleCloseImageModal}
                imageSrc={selectedImage}
        />
      </Box>
    </Box>
  );
};

export default PrestamoAmoxarifado;